export class NotificationConfiguration {
  icon: string;
  title: string;
  description: string;
  color: string;
}
